import { DOCUMENT } from '@angular/common';
import { EventEmitter, Inject, Injectable } from '@angular/core';

import { Dimension } from '../models/dto';

@Injectable({
  providedIn: 'root'
})
export class ContainerService {

  public messages: string[] = [];
  public scrollEvent = new EventEmitter();
  public windowResizeEvent = new EventEmitter();
  public colorEvent = new EventEmitter();
  public showScrollToTopButtonEvent = new EventEmitter();
  public id: string;
  public container: HTMLDivElement;
  public isMobile: boolean = null;
  public dimension: Dimension = new Dimension();

  constructor(@Inject(DOCUMENT) private document: Document) { }

  setScrollingContainer(id: string = 'scrollingContainer', showScrollToTopButton: boolean = true) {
    this.id = id;
    this.container = this.document.getElementById(id) as HTMLDivElement;

    if (this.container != null) {
      this.container.onscroll = () => this.scrollEvent.emit(this.container.scrollTop);

      if (this.id == 'scrollingContainer') {
        this.colorEvent.emit('#e91e63');
      } else {
        this.colorEvent.emit('#004987');
      }

      this.showScrollToTopButtonEvent.emit(showScrollToTopButton);
    }
  }

  setColor(color: string) {
    if (!!color) {
      this.colorEvent.emit(color);
    }
  }

  scrollToTop(smooth: boolean = true) {
    this.scroll(0, smooth);
  }

  scrollToBottom(smooth: boolean = true) {
    this.scroll(-1, smooth);
  }

  scrollToPosition(y: number, smooth: boolean = true) {
    this.scroll(y, smooth);
  }

  private scroll(top: number, smooth: boolean) {
    if (this.container != null) {
      this.container.scroll({ top: top >= 0 ? top : this.container.scrollHeight, left: 0, behavior: smooth ? 'smooth' : 'auto' });
    } else if (!!this.id) {
      this.container = this.document.getElementById(this.id) as HTMLDivElement;

      if (this.container != null) {
        this.container.onscroll = () => this.scrollEvent.emit(this.container.scrollTop);
        this.container.scroll({ top: top >= 0 ? top : this.container.scrollHeight, left: 0, behavior: smooth ? 'smooth' : 'auto' });
      }
    }
  }
}